import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";
import Publications from "../img/publications.png";
import Introduction_img from "../img/inrtoduction_image.png";
import Sub_cohorts_img from "../img/sub-cohorts.png";
import Crow_img_1 from "../img/Crow/3.png";
import Crow_img_2 from "../img/Crow/4.png";
import Crow_img_3 from "../img/Crow/5.png";
const Table = styled.table`
margin : 30px 0 ;
font-size : 20px;

`
const Table_title= styled.a`
font-family: "Publication_link"; 
margin : 10px 0 ;       
    font-size : 20px;
    color : #32A4FF;
    font-weight : bold;
    &:hover{cursor:pointer;}
`
const Table_title_2= styled.a`
width : 200px;
text-align : center;
font-family: "Publication_link"; 
display : inline-block; 
color : #0D47A1;
margin : 10px 20px ;       
    font-size : 27px;
    font-weight : bold;
    &:hover{cursor:pointer;    color : #32A4FF;
    }
`
const TR = styled.tr`

`

const TD = styled.td`
padding : 15px 0;
&:nth-child(1){
    width : 280px;
    font-weight : bold;
    font-family: "Table_title";        
}
&:nth-child(2){
    width : 920px;
    font-family: "Table_content";        
}
line-height : 30px;
`
const Title_span = styled.span`
    display : inline-block;
    font-size : 35px; 
    font-weight : bold;
    margin : 50px 0 ;
    `
const Wrapper_div = styled.div`
    margin : 0 10%;
`

function Publication(){
    return(
    <Wrapper_div>
        <Title_span>
        Here Is More Information           
        </Title_span>
        <Table_title_2 href="https://snucm.elsevierpure.com/en/persons/y-jeong-7" target="_blank">Research profile</Table_title_2> 
        <Table_title_2 href="https://scholar.google.co.kr/citations?hl=ko&user=ggc_6m0AAAAJ&view_op=list_works&sortby=pubdate" target="_blank">Google scholar</Table_title_2>

        <Title_span_>Selected Publications</Title_span_>
        <br/>
        <Title_span >2021</Title_span>
        <div>
        <Table_title href="https://pubmed.ncbi.nlm.nih.gov/33527588/" target="_blank">
            Targeted therapy response in early versus late recurrence of renal cell carcinoma after surgical treatment: A propensity score-matched study using the Korean Renal Cancer Study Group database.
        </Table_title>
        <Table><TR><TD>Authors</TD><TD>
            Lee CH, Chung J, Kwak C, Jeong CW, Seo SI, Kang M, Hong SH, Song C, Park JY, Hwang EC, Lee H, Ku JY, Seo WI, Choi SH, Ha HK; Korean Renal Cancer Study Group.
        </TD>
        </TR><TR><TD>Journal Information</TD><TD>Int J Urol. 2021 Apr;28(4):417-423. doi: 10.1111/iju.14485. Epub 2021 Feb 1.</TD></TR>
        <TR><TD>PMID</TD><TD>33527588</TD>
        </TR>
        </Table>
        </div>
                <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33542395/">Prognostic significance of pathologic nodal positivity in non-metastatic patients with renal cell carcinoma who underwent radical or partial nephrectomy.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Kim SH, Park B, Hwang EC, Hong SH, Jeong CW, Kwak C, Byun SS, Chung J.
</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Sci Rep. 2021 Feb 4;11(1):3079. doi: 10.1038/s41598-021-82750-y.</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>33542395 Free PMC article.</TD>
                </TR>
            </Table>
        </div>
                <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33047324/">	
Metastatic renal cell carcinoma to the pancreas: Clinical features and treatment outcome.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Shin TJ, Song C, Jeong CW, Kwak C, Seo S, Kang M, Chung J, Hong SH, Hwang EC, Park JY, Lee H.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>J Surg Oncol. 2021 Jan;123(1):204-213. doi: 10.1002/jso.26251. Epub 2020 Oct 12.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>33047324</TD>
                </TR>
            </Table>
        </div>
                <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33939273/">	
Comprehensive metabolomic profiling in early IgA nephropathy patients reveals urine glycine as a prognostic biomarker.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Park S, Lee J, Yang SH, Lee H, Kim JY, Park M, Kim KH, Moon JJ, Cho S, Lee S, Kim Y, Lee H, Lee JP, Jeong CW, Kwak C, Joo KW, Lim CS, Kim YS, Hwang GS, Kim DK.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>J Cell Mol Med. 2021 May 3. doi: 10.1111/jcmm.16520. Online ahead of print.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>33939273</TD>
                </TR>
            </Table>
        </div>
                <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32712166/">Fumarate modulates phospholipase A2 receptor autoimmunity-induced podocyte injury in membranous nephropathy.
</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Jo HA, Hyeon JS, Yang SH, Jung Y, Ha H, Jeong CW, Kwak C, Kim Y, Lee H, Lee JP, Joo KW, Lim CS, Kim YS, Hwang GS, Kim DK.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Kidney Int. 2021 Feb;99(2):443-455. doi: 10.1016/j.kint.2020.06.031. Epub 2020 Jul 23.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32712166</TD>
                </TR>
            </Table>
        </div>
                <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32631709/">	
Impact of short warm ischemic time on longitudinal kidney function and survival rate after partial nephrectomy for renal cell carcinoma in patients with pre-existing chronic kidney disease stage III: A multi-institutional propensity score-matched study.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Chung JS, Hong SK, Lee SC, Jeong CW, Kwak C, Kim HH, Hong SH, Kim YJ, Kang SH, Chung J, Kwon TG, Hwang EC, Byun SS.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Eur J Surg Oncol. 2021 Feb;47(2):470-476. doi: 10.1016/j.ejso.2020.06.016. Epub 2020 Jun 17.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32631709</TD>
                </TR>
            </Table>
        </div>
        <div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33637585/">Head to head comparison of 68Ga-NGUL and 68Ga-PSMA-11 in patients with metastatic prostate cancer: a prospective study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Suh M, Im HJ, Ryoo HG, Kang KW, Jeong JM, Prakash S, Ballal SS, Yadav MP, Bal C, Jeong CW, Kwak C, Cheon GJ.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Nucl Med. 2021 Feb 26:jnumed.120.258434. doi: 10.2967/jnumed.120.258434. Online ahead of print.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>33637585</TD>

        </TR>
    </Table>
</div>

<Title_span >2020</Title_span>


        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33369661/">	
Regional Variation in Active Surveillance for Low-Risk Prostate Cancer in the US.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Washington SL 3rd, Jeong CW, Lonergan PE, Herlemann A, Gomez SL, Carroll PR, Cooperberg MR.
</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>JAMA Netw Open. 2020 Dec 1;3(12):e2031349. doi: 10.1001/jamanetworkopen.2020.31349.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>33369661 Free PMC article.</TD>
                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33060077/">	
Efficacy of neoadjuvant atezolizumab treatment in patients with advanced urothelial bladder cancer according to the BASQ classification: a study protocol for an open-label, two-cohort, phase II trial.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Yuk HD, Jeong CW, Kwak C, Kim H, Moon KC, Ku JH.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>BMJ Open. 2020 Oct 15;10(10):e035530. doi: 10.1136/bmjopen-2019-035530.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>33060077 Free PMC article.</TD>
                </TR>
            </Table>
        </div>

        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32992891/">	
Scale-Up Evaluation of a Composite Tumor Marker Assay for the Early Detection of Renal Cell Carcinoma.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Kim DS, Ham WS, Jang WS, Cho KS, Choi YD, Kang S, Kim B, Kim KJ, Lim EJ, Rha SY, Ku JH, Kwak C, Kim HH, Jeong CW, Cho NH.
</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Diagnostics (Basel). 2020 Sep 25;10(10):750. doi: 10.3390/diagnostics10100750.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32992891 Free PMC article.</TD>
                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32954852/">RNA-Seq profiling of microdissected glomeruli identifies potential biomarkers for human IgA nephropathy.
</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Park S, Yang SH, Jeong CW, Moon KC, Kim DK, Joo KW, Kim YS, Lee JW, Lee H.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Am J Physiol Renal Physiol. 2020 Nov 1;319(5):F809-F821. doi: 10.1152/ajprenal.00037.2020. Epub 2020 Sep 21.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32954852</TD>
                </TR>
            </Table>
        </div>

        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32869150/">	
Role of multiparametric magnetic resonance imaging to predict postoperative Gleason score upgrading in prostate cancer with Gleason score 3 + 4.</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Kim H, Kim JK, Hong SK, Jeong CW, Ku JH, Kwak C.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>World J Urol. 2020 Aug 31. doi: 10.1007/s00345-020-03421-7. Online ahead of print.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32869150</TD>
                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32811483/">Sharing the initial experience of pan-cancer panel analysis in high-risk renal cell carcinoma in the Korean population.
</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Suh J, Jeong CW, Choi S, Ku JH, Kim HH, Kim K, Kwak C.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>BMC Urol. 2020 Aug 18;20(1):125. doi: 10.1186/s12894-020-00687-2.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32811483 Free PMC article.</TD>
                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32734724/">The platelet-to-lymphocyte ratio as a significant prognostic factor to predict survival outcomes in patients with synchronous metastatic renal cell carcinoma.
</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Yuk HD, Kang M, Hwang EC, Park JY, Jeong CW, Song C, Seo SI, Byun SS, Kwak C, Hong SH, Chung J, Lee H; Korean Renal Cancer Study (KRoCS) Group.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Investig Clin Urol. 2020 Sep;61(5):475-481. doi: 10.4111/icu.20200002. Epub 2020 Jul 23.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32734724 Free PMC article.</TD>
                </TR>
            </Table>
        </div>

        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32576921/">Differences in risk factors for biochemical recurrence after radical prostatectomy stratified by the degree of obesity: Focused on surgical methods.
</Table_title>
            <Table>
                <TR>
                    <TD>Authors</TD><TD>Suh J, Yoo S, Park J, Cho MC, Jeong CW, Ku JH, Kwak C, Kim HH, Jeong H.

</TD>
                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Sci Rep. 2020 Jun 23;10(1):10157. doi: 10.1038/s41598-020-67237-6.
</TD>
                </TR>
                <TR>
                    <TD>PMID</TD><TD>32576921 Free PMC article.</TD>
                </TR>
            </Table>
        </div>

        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32490843/">Information Technology-Based Management of Clinically Healthy COVID-19 Patients: Lessons From a Living and Treatment Support Center Operated by Seoul National University Hospital.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Bae YS, Kim KH, Choi SW, Ko T, Jeong CW, Cho B, Kim MS, Kang E.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>J Med Internet Res. 2020 Jun 12;22(6):e19938. doi: 10.2196/19938.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32490843 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32676410/">Survival benefit of neoadjuvant chemotherapy in pathologic T2N0 or lower urothelial carcinoma patients: evidence to support the use of neoadjuvant chemotherapy.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Yuk HD, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Transl Androl Urol. 2020 Jun;9(3):1270-1277. doi: 10.21037/tau-19-705.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32676410 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33425793/">Korean version of the convalescence and recovery evaluation: translation and linguistic validation.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Yuk HD, Kim JJ, Ku JH, Kwak C, Kim HH, Jeong CW.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Prostate Int. 2020 Dec;8(4):158-166. doi: 10.1016/j.prnil.2020.05.001. Epub 2020 May 27.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>33425793 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
                
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/33134826/">The Relative Impact of Urinary and Sexual Function vs Bother on Health Utility for Men With Prostate Cancer.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Jeong CW, Herlemann A, Cowan JE, Broering JM, Ten Ham RMT, Wilson LS, Carroll PR, Cooperberg MR.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>JNCI Cancer Spectr. 2020 May 25;4(5):pkaa044. doi: 10.1093/jncics/pkaa044. eCollection 2020 Oct.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>33134826 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32412421/">Clinical Desire for an Artificial Intelligence-Based Surgical Assistant System: Electronic Survey-Based Study.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Park SJ, Lee EJ, Kim SI, Kong SH, Jeong CW, Kim HS.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>JMIR Med Inform. 2020 May 15;8(5):e17647. doi: 10.2196/17647.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32412421 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32384474/">Comprehensive analysis of mutations of renal cell carcinoma in an autosomal dominant polycystic kidney disease patient.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Shim KE, Lee C, Kim JU, Choi GH, Kwak KM, Kim SH, Kim H, Yoon JW, Shin TY, Jeong CW, Kim H.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Medicine (Baltimore). 2020 May;99(19):e20071. doi: 10.1097/MD.0000000000020071.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32384474 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32332797/">The number of metabolic features as a significant prognostic factor in patients with metastatic renal cell carcinoma.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Yuk HD, Hwang EC, Park JY, Jeong CW, Song C, Seo SI, Byun SS, Kwak C, Hong SH, Kang M, Chung J, Lee H.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Sci Rep. 2020 Apr 24;10(1):6967. doi: 10.1038/s41598-020-63816-9.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32332797 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32377602/">Long-term oncologic outcomes after radical prostatectomy in clinically localized prostate cancer: 10-year follow-up in Korea.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Suh J, Jung JH, Jeong CW, Lee SE, Lee E, Ku JH, Kim HH, Kwak C.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Investig Clin Urol. 2020 May;61(3):269-276. doi: 10.4111/icu.2020.61.3.269. Epub 2020 Apr 21.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32377602 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank"  href="https://pubmed.ncbi.nlm.nih.gov/32377601/">Development of the clinical calculator for mortality of patients with metastatic clear cell type renal cell carcinoma: An analysis of patients from Korean Renal Cancer Study Group database.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Park JY, Tae BS, Jeong CW, Song C, Seo SI, Hong SK, Chung J, Hong SH, Hwang EC, Kwak C, Seo IY, Park S, Park C; Korean Renal Cancer Study Group.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Investig Clin Urol. 2020 May;61(3):260-268. doi: 10.4111/icu.2020.61.3.260. Epub 2020 Mar 10.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32377601 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32106477/">Robust Association between Acute Kidney Injury after Radical Nephrectomy and Long-term Renal Function.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Kim WH, Shin KW, Ji SH, Jang YE, Lee JH, Jeong CW, Kwak C, Lim YJ.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>J Clin Med. 2020 Feb 25;9(3):619. doi: 10.3390/jcm9030619.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32106477 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/32158963/">Targeted next-generation sequencing for locally advanced prostate cancer in the Korean population.
</Table_title>

        <Table>
                <TR>
                    <TD>Authors</TD><TD>Suh J, Jeong CW, Choi S, Ku JH, Kim HH, Kim KS, Kwak C.</TD>

                </TR>
                <TR>
                    <TD>Journal Information</TD><TD>Investig Clin Urol. 2020 Mar;61(2):127-135. doi: 10.4111/icu.2020.61.2.127. Epub 2020 Feb 10.</TD>

                </TR>
                <TR>
                    <TD>PMID</TD><TD>32158963 Free PMC article.</TD>

                </TR>
            </Table>
        </div>
        <div>
        <Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31980309/">The New Surveillance, Epidemiology, and End Results Prostate with Watchful Waiting Database: Opportunities and Limitations.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Washington SL 3rd, Herlemann A, Gomez SL, Carroll PR, Cooperberg MR.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Eur Urol. 2020 Sep;78(3):335-344. doi: 10.1016/j.eururo.2020.01.009. Epub 2020 Jan 21.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31980309</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31866225/">Long-term Mortality Risks Among Living Kidney Donors in Korea.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim Y, Yu MY, Yoo KD, Jeong CW, Kim HH, Min SI, Ha J, Choi Y, Ko AR, Yun JM, Park SM, Yang SH, Kim DK, Oh KH, Joo KW, Ahn C, Kim YS, Lee H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Am J Kidney Dis. 2020 Jun;75(6):919-925. doi: 10.1053/j.ajkd.2019.09.015. Epub 2019 Dec 19.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31866225</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31942459/">Enzalutamide in chemotherapy-naive patients with metastatic castration-resistant prostate cancer: A retrospective Korean multicenter study in a real-world setting.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jung SI, Kim MS, Jeong CW, Kwak C, Hong SK, Kang SH, Joung JY, Lee SH, Yun SJ, Kim TH, Park SW, Jeon SS, Kang M, Lee JY, Chung BH, Hong JH, Ahn H, Kim CS, Kwon DD.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Investig Clin Urol. 2020 Jan;61(1):19-27. doi: 10.4111/icu.2020.61.1.19. Epub 2019 Dec 10.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31942459 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31694041/">Patients with Biopsy Gleason Score 3 + 4 Are Not Appropriate Candidates for Active Surveillance.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Park J, Yoo S, Cho MC, Jeong CW, Ku JH, Kwak C, Kim HH, Jeong H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urol Int. 2020;104(3-4):199-204. doi: 10.1159/000503888. Epub 2019 Nov 6.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31694041</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31235435/">Korean version of the G-8 geriatric screening tool: Translation and linguistic validation.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yuk HD, Kim JJ, Ku JH, Kwak C, Kim HH, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Geriatr Oncol. 2020 Apr;11(3):470-474. doi: 10.1016/j.jgo.2019.06.002. Epub 2019 Jun 22.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31235435</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31103393/">Establishment of Novel Intraoperative Monitoring and Mapping Method for the Cavernous Nerve During Robot-assisted Radical Prostatectomy: Results of the Phase I/II, First-in-human, Feasibility Study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Song WH, Park JH, Tae BS, Kim SM, Hur M, Seo JH, Ku JH, Kwak C, Kim HH, Kim K, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Eur Urol. 2020 Aug;78(2):221-228. doi: 10.1016/j.eururo.2019.04.042. Epub 2019 May 16.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31103393</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31806771/">Differential Expression of Glucose Transporters and Hexokinases in Prostate Cancer with a Neuroendocrine Gene Signature: A Mechanistic Perspective for 18F-FDG Imaging of PSMA-Suppressed Tumors.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Bakht MK, Lovnicki JM, Tubman J, Stringer KF, Chiaramonte J, Reynolds MR, Derecichei I, Ferraiuolo RM, Fifield BA, Lubanska D, Oh SW, Cheon GJ, Kwak C, Jeong CW, Kang KW, Trant JF, Morrissey C, Coleman IM, Wang Y, Ahmadzadehfar H, Dong X, Porter LA.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Nucl Med. 2020 Jun;61(6):904-910. doi: 10.2967/jnumed.119.231068. Epub 2019 Dec 5.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31806771 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<Title_span >2019</Title_span>
                                                                        
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31649294/">BCG instillation versus radical cystectomy for high-risk NMIBC with squamous/glandular histologic variants.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Suh J, Moon KC, Jung JH, Lee J, Song WH, Kang YJ, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Sci Rep. 2019 Oct 24;9(1):15268. doi: 10.1038/s41598-019-51889-0.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31649294 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31554223/">General Anesthetic Agents and Renal Function after Nephrectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee HJ, Bae J, Kwon Y, Jang HS, Yoo S, Jeong CW, Kim JT, Kim WH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Clin Med. 2019 Sep 24;8(10):1530. doi: 10.3390/jcm8101530.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31554223 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31500577/">Acute Kidney Injury Adjusted for Parenchymal Mass Reduction and Long-Term Renal Function after Partial Nephrectomy.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Yoon HK, Lee HJ, Yoo S, Park SK, Kwon Y, Jun K, Jeong CW, Kim WH.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BMC Cancer. 2019 Sep 9;19(1):897. doi: 10.1186/s12885-019-6042-1.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31500577 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31552183/">Retrospective Multicenter Long-Term Follow-up Analysis of Prognostic Risk Factors for Recurrence-Free, Metastasis-Free, Cancer-Specific, and Overall Survival After Curative Nephrectomy in Non-metastatic Renal Cell Carcinoma.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Kim SH, Park B, Hwang EC, Hong SH, Jeong CW, Kwak C, Byun SS, Chung J.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Front Oncol. 2019 Sep 4;9:859. doi: 10.3389/fonc.2019.00859. eCollection 2019.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31552183 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31438204/">Development of Integrated Data and Prediction System Platform for the Localized Prostate Cancer.
</Table_title>
 
<Table>
        <TR>
            <TD>Authors</TD><TD>Lee SJ, Yu SH, Kim Y, Hong JH, Kim CS, Seo SI, Jeong CW, Byun SS, Chung BH, Lee JY, Choi IY.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Stud Health Technol Inform. 2019 Aug 21;264:1506-1507. doi: 10.3233/SHTI190507.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31438204</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31345635/">Robust Health Utility Assessment Among Long-term Survivors of Prostate Cancer: Results from the Cancer of the Prostate Strategic Urologic Research Endeavor Registry.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Cowan JE, Broering JM, Ten Ham RMT, Wilson LS, Carroll PR, Cooperberg MR.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Eur Urol. 2019 Dec;76(6):743-751. doi: 10.1016/j.eururo.2019.07.012. Epub 2019 Jul 23.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31345635</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31258727/">Prostate specific antigen (PSA) persistence 6 weeks after radical prostatectomy and pelvic lymph node dissection as predictive factor of radiographic progression in node-positive prostate cancer patients.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Cancer. 2019 May 21;10(10):2237-2242. doi: 10.7150/jca.29714. eCollection 2019.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31258727 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31294132/">Establishment of the Seoul National University Prospectively Enrolled Registry for Genitourinary Cancer (SUPER-GUC): A prospective, multidisciplinary, bio-bank linked cohort and research platform.
</Table_title>
 
<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Suh J, Yuk HD, Tae BS, Kim M, Keam B, Kim JH, Kim SY, Cho JY, Kim SH, Moon KC, Cheon GJ, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Investig Clin Urol. 2019 Jul;60(4):235-243. doi: 10.4111/icu.2019.60.4.235. Epub 2019 May 20.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31294132 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31070307/">Survival and clinical prognostic factors in metastatic non-clear cell renal cell carcinoma treated with targeted therapy: A multi-institutional, retrospective study using the Korean metastatic renal cell carcinoma registry.</Table_title>


<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Kim SH, Song MK, Joo J, Seo SI, Kwak C, Jeong CW, Song C, Hwang EC, Seo IY, Lee H, Hong SH, Park JY, Chung J.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Cancer Med. 2019 Jul;8(7):3401-3410. doi: 10.1002/cam4.2222. Epub 2019 May 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31070307 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/31085754/">Is Primary Androgen Deprivation Therapy a Suitable Option for Asian Patients With Prostate Cancer Compared With Radical Prostatectomy?</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ha US, Choi JB, Shim JI, Kang M, Park E, Kang S, Park J, Yang J, Choi I, Ahn J, Kwak C, Jeong CW, Kim CS, Byun SS, Seo SI, Lee HM, Lee SJ, Lee SH, Chung BH, Lee JY.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Natl Compr Canc Netw. 2019 May 1;17(5):441-449. doi: 10.6004/jnccn.2018.7265.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>31085754</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30679704/">The association between intraoperative urine output and postoperative acute kidney injury differs between partial and radical nephrectomy.</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Hur M, Park SK, Yoo S, Choi SN, Jeong CW, Kim WH, Kim JT, Kwak C, Bahk JH.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Sci Rep. 2019 Jan 24;9(1):760. doi: 10.1038/s41598-018-37432-7.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30679704 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30705874/">Elevated Neutrophil to Lymphocyte Ratio Predicts Poor Prognosis in Non-muscle Invasive Bladder Cancer Patients: Initial Intravesical Bacillus Calmette-Guerin Treatment After Transurethral Resection of Bladder Tumor Setting.</Table_title>


<Table>
        <TR>
            <TD>Authors</TD><TD>Yuk HD, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Front Oncol. 2019 Jan 17;8:642. doi: 10.3389/fonc.2018.00642. eCollection 2018.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30705874 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30782419/">Effects of Variant Histology on the Oncologic Outcomes of Patients With Upper Urinary Tract Carcinoma After Radical Nephroureterectomy: A Propensity Score-Matched Analysis.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Chung HS, Hwang EC, Kim MS, Yu SH, Jung SI, Kang TW, Choi C, Choi SH, Kwon TG, Noh JH, Kim MK, Cho WJ, Kang SG, Kang SH, Cheon J, Seo IY, Chung H, Kim HS, Lee CH, Ku JY, Ha HK, Kim BH, Jeong CW, Ku JH, Kwak C, Kwon D.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2019 Jun;17(3):e394-e407. doi: 10.1016/j.clgc.2018.11.015. Epub 2019 Jan 11.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30782419</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30808214/">Influence of Tumor Thrombus on Occurrence of Distant Venous Thromboembolism and Survival in Patients With Renal Cell Carcinoma After Surgery.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Park H, Jeong CW, Yuk H, Ku JH, Kim HH, Kwak C, Kim I.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Appl Thromb Hemost. 2019 Jan-Dec;25:1076029618823288. doi: 10.1177/1076029618823288.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30808214 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30214035/">Importance of androgen-deprivation therapy during enzalutamide treatment in men with metastatic castration-resistant prostate cancer following chemotherapy: results from retrospective, multicenter data.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Kang M, Il Jung S, Kim TH, Park SW, Joung JY, Jeon SS, Hong JH, Lee JY, Chung BH, Ahn H, Kim CS, Kwon DD, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Prostate Cancer Prostatic Dis. 2019 Mar;22(1):150-158. doi: 10.1038/s41391-018-0088-z. Epub 2018 Sep 13.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30214035</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30189720/">Application of the International Metastatic Renal Cell Carcinoma Database Consortium and Memorial Sloan Kettering Cancer Center Risk Models in Patients with Metastatic Non-Clear Cell Renal Cell Carcinoma: A Multi-Institutional Retrospective Study Using the Korean Metastatic Renal Cell Carcinoma Registry.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Kim SH, Song MK, Joo J, Seo SI, Kwak C, Jeong CW, Song C, Hwang EC, Seo IY, Lee H, Hong SH, Park JY, Chung J.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Cancer Res Treat. 2019 Apr;51(2):758-768. doi: 10.4143/crt.2018.421. Epub 2018 Sep 7.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30189720 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<Title_span >2018</Title_span>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30619691/">Maternal and fetal outcomes of pregnancies in kidney donors: A 30-year comparative analysis of matched non-donors in a single center.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yoo KD, Lee H, Kim Y, Park S, Park JS, Hong JS, Jeong CW, Kim HH, Lee JP, Kim DK, Oh KH, Joo KW, Kim YS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Kidney Res Clin Pract. 2018 Dec;37(4):356-365. doi: 10.23876/j.krcp.18.0050. Epub 2018 Dec 31.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30619691 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
    
<Table>
        <TR>
            <TD>Authors</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD>
        </TR>
        <TR>
            <TD>PMID</TD>
        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30496283/">Should intravesical Bacillus Calmette-Guerin (BCG) treatment be administered to patients with T0 after repeat transurethral resection of bladder tumor in patients with high-risk non-muscle invasive bladder cancer?</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yuk HD, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2018 Nov 29;13(11):e0208267. doi: 10.1371/journal.pone.0208267. eCollection 2018.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30496283 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30400059/">Neuroendocrine differentiation of prostate cancer leads to PSMA suppression.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Bakht MK, Derecichei I, Li Y, Ferraiuolo RM, Dunning M, Oh SW, Hussein A, Youn H, Stringer KF, Jeong CW, Cheon GJ, Kwak C, Kang KW, Lamb AD, Wang Y, Dong X, Porter LA.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Endocr Relat Cancer. 2018 Nov 23;26(2):131-146. doi: 10.1530/ERC-18-0226.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30400059</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30546281/">Efficacy of First-Line Targeted Therapy in Real-World Korean Patients with Metastatic Renal Cell Carcinoma: Focus on Sunitinib and Pazopanib.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim MS, Chung HS, Hwang EC, Jung SI, Kwon DD, Hwang JE, Bae WK, Park JY, Jeong CW, Kwak C, Song C, Seo SI, Byun SS, Hong SH, Chung J.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Korean Med Sci. 2018 Nov 22;33(51):e325. doi: 10.3346/jkms.2018.33.e325. eCollection 2018 Dec 17.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30546281 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30374152/">Lymphovascular invasion have a similar prognostic value as lymph node involvement in patients undergoing radical cystectomy with urothelial carcinoma.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yuk HD, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Sci Rep. 2018 Oct 29;8(1):15928. doi: 10.1038/s41598-018-34299-6.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30374152 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30183076/">Histone demethylase KDM7A controls androgen receptor activity and tumor growth in prostate cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee KH, Hong S, Kang M, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Cancer. 2018 Dec 1;143(11):2849-2861. doi: 10.1002/ijc.31843. Epub 2018 Oct 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30183076</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30344463/">Partial versus Radical Nephrectomy for T1-T2 Renal Cell Carcinoma in Patients with Chronic Kidney Disease Stage III: a Multiinstitutional Analysis of Kidney Function and Survival Rate.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Chung JS, Son NH, Lee SE, Hong SK, Jeong CW, Kwak C, Kim HH, Hong SH, Kim YJ, Kang SH, Chung J, Kwon TG, Hwang EC, Byun SS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Korean Med Sci. 2018 Oct 1;33(43):e277. doi: 10.3346/jkms.2018.33.e277. eCollection 2018 Oct 22.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30344463 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30271788/">Differences in Pathologic Results of Repeat Transurethral Resection of Bladder Tumor (TURBT) according to Institution Performing the Initial TURBT: Comparative Analyses between Referred and Nonreferred Group.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yuk HD, Kim JK, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Biomed Res Int. 2018 Sep 6;2018:9432606. doi: 10.1155/2018/9432606. eCollection 2018.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30271788 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29940249/">Changeable Conditional Survival Rates and Associated Prognosticators in Patients with Metastatic Renal Cell Carcinoma Receiving First Line Targeted Therapy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Park JY, Jeong CW, Hwang EC, Song C, Hong SH, Kwak C, Chung J, Sung HH, Jeon HG, Jeong BC, Park SH, Jeon SS, Lee HM, Choi HY, Seo SI.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Urol. 2018 Nov;200(5):989-995. doi: 10.1016/j.juro.2018.06.030. Epub 2018 Jun 22.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29940249</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29854755/">The Impact of Pathologic Upgrading of Gleason Score 7 Prostate Cancer on the Risk of the Biochemical Recurrence after Radical Prostatectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Park J, Yoo S, Cho MC, Cho MH, Jeong CW, Ku JH, Kwak C, Kim HH, Jeong H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Biomed Res Int. 2018 Apr 30;2018:4510149. doi: 10.1155/2018/4510149. eCollection 2018.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29854755 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29755715/">A Deep Belief Network and Dempster-Shafer-Based Multiclassifier for the Pathology Stage of Prostate Cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Choi MJ, Lee JS, Hong JH, Kim CS, Seo SI, Jeong CW, Byun SS, Koo KC, Chung BH, Park YH, Lee JY, Choi IY.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Healthc Eng. 2018 Mar 19;2018:4651582. doi: 10.1155/2018/4651582. eCollection 2018.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29755715 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30505816/">Comparative quality-adjusted survival analysis between radiation therapy alone and radiation with androgen deprivation therapy in patients with locally advanced prostate cancer: a secondary analysis of Radiation Therapy Oncology Group 85-31 with novel decision analysis methods.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ahn S, Lee M, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Prostate Int. 2018 Dec;6(4):140-144. doi: 10.1016/j.prnil.2018.01.002. Epub 2018 Feb 2.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30505816 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29381018/">Prognostic value of preoperative systemic inflammation markers in localized upper tract urothelial cell carcinoma: a large, multicenter cohort analysis.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Son S, Hwang EC, Jung SI, Kwon DD, Choi SH, Kwon TG, Noh JH, Kim MK, Seo IY, Kim CS, Kang SG, Cheon J, Ha HK, Jeong CW, Ku JH, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Minerva Urol Nefrol. 2018 Jun;70(3):300-309. doi: 10.23736/S0393-2249.18.02914-4. Epub 2018 Jan 29.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29381018</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29364958/">Comparisons of oncological outcomes and perioperative complications between laparoscopic and open radical nephrectomies in patients with clinical T2 renal cell carcinoma (≥7cm).
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee H, Lee CU, Yoo JH, Sung HH, Jeong BC, Jeon SS, Lee HM, Choi HY, Jeong CW, Kwak C, Seo SI.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2018 Jan 24;13(1):e0191786. doi: 10.1371/journal.pone.0191786. eCollection 2018.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29364958 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29215822/">Eleven-year Cumulative Incidence and Estimated Lifetime Prevalence of Urolithiasis in Korea: a National Health Insurance Service-National Sample Cohort Based Study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Tae BS, Balpukov U, Cho SY, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Korean Med Sci. 2018 Jan 8;33(2):e13. doi: 10.3346/jkms.2018.33.e13.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29215822 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/30317229/">Comparison of Renal Function after Radical Surgery for Upper Tract Urothelial Carcinoma versus Renal Cell Carcinoma: Propensity Score Matching.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Tae BS, Ku JH, Kwak C, Kim HH, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urol Int. 2018;101(4):400-408. doi: 10.1159/000493763. Epub 2018 Oct 12.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>30317229</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29333509/">Rate and association of lower urinary tract infection with recurrence after transurethral resection of bladder tumor.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim BS, Tae BS, Ku JH, Kwak C, Kim HH, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Investig Clin Urol. 2018 Jan;59(1):10-17. doi: 10.4111/icu.2018.59.1.10. Epub 2017 Dec 15.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29333509 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29081218/">Effects of Aspirin, Nonsteroidal Anti-inflammatory Drugs, Statin, and COX2 Inhibitor on the Developments of Urological Malignancies: A Population-Based Study with 10-Year Follow-up Data in Korea.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Ku JH, Kwak C, Kim HH, Jeong CW.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Cancer Res Treat. 2018 Jul;50(3):984-991. doi: 10.4143/crt.2017.248. Epub 2017 Oct 27.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29081218 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28421726/">Selection Criteria for Active Surveillance of Patients with Prostate Cancer in Korea: A Multicenter Analysis of Pathology after Radical Prostatectomy.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Hong SK, Byun SS, Jeon SS, Seo SI, Lee HM, Ahn H, Kwon DD, Ha HK, Kwon TG, Chung JS, Kwak C, Kim HJ.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Cancer Res Treat. 2018 Jan;50(1):265-274. doi: 10.4143/crt.2016.477. Epub 2017 Apr 14.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28421726 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<Title_span >2017</Title_span>


<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/29244843/">Pathology in repeated transurethral resection of a bladder tumor as a risk factor for prognosis of high-risk non-muscle-invasive bladder cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Tae BS, Jeong CW, Kwak C, Kim HH, Moon KC, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2017 Dec 15;12(12):e0189354. doi: 10.1371/journal.pone.0189354. eCollection 2017.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>29244843 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28910332/">Concurrent treatment with simvastatin and NF-κB inhibitor in human castration-resistant prostate cancer cells exerts synergistic anti-cancer effects via control of the NF-κB/LIN28/let-7 miRNA signaling pathway.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Lee KH, Lee HS, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2017 Sep 14;12(9):e0184644. doi: 10.1371/journal.pone.0184644. eCollection 2017.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28910332 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28928878/">Papillary Urothelial Neoplasm of Low Malignant Potential (PUNLMP) After Initial TUR-BT: Comparative Analyses with Noninvasive Low-Grade Papillary Urothelial Carcinoma (LGPUC).
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Moon KC, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Cancer. 2017 Aug 24;8(15):2885-2891. doi: 10.7150/jca.20003. eCollection 2017.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28928878 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28823006/">Impact of Gleason score on biochemical recurrence in patients with pT3aN0/Nx prostate cancer with positive surgical margins: a multicenter study from the Prostate Cancer Research Committee.
</Table_title>
 
<Table>
        <TR>
            <TD>Authors</TD><TD>Song W, Lee DH, Jeon HG, Jeong BC, Seo SI, Lee HM, Choi HY, Kim JW, Lee S, Byun SS, Jeong CW, Kwak C, Cho JS, Ahn H, Jeon SS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Cancer Res Clin Oncol. 2017 Nov;143(11):2393-2400. doi: 10.1007/s00432-017-2502-7. Epub 2017 Aug 19.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28823006</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28802888/">Predictors for Intravesical Recurrence Following Radical Nephroureterectomy for Upper Tract Urothelial Carcinoma: A National Multicenter Analysis.</Table_title>


<Table>
        <TR>
            <TD>Authors</TD><TD>Lee CH, Ku JY, Jeong CW, Ku JH, Kwak C, Kim HH, Tae BS, Choi SH, Kim HT, Kim TH, Kwon TG, Hwang EC, Jung SI, Kang TW, Kwon DD, Ha HK.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2017 Dec;15(6):e1055-e1061. doi: 10.1016/j.clgc.2017.07.009. Epub 2017 Jul 22.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28802888</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28681039/">Prevalence and management status of urologic disease in geriatric hospitals in South Korea: A population-based analysis.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Suh J, Kim KH, Lee SH, Kim HS, Lee YJ, Lee SR, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Investig Clin Urol. 2017 Jul;58(4):281-288. doi: 10.4111/icu.2017.58.4.281. Epub 2017 Jun 27.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28681039 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28560602/">Progression to T1 High Grade (T1HG) from a Lower Stage/Grade is Associated with Poorer Survival Outcomes than Initial Diagnosis with T1HG Bladder Cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Ann Surg Oncol. 2017 Aug;24(8):2413-2419. doi: 10.1245/s10434-017-5902-7. Epub 2017 May 30.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28560602</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28558989/">Preoperative Cholesterol Level Is Associated With Worse Pathological Outcomes and Postoperative Survival in Localized Renal Cell Carcinoma Patients: A Propensity Score-Matched Study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee H, Jeong CW, Kwak C, Kim HH, Seo SI, Lee HM, Oh JJ, Lee SC, Hong SK, Lee SE, Byun SS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2017 Dec;15(6):e935-e941. doi: 10.1016/j.clgc.2017.05.008. Epub 2017 May 10.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28558989</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28484945/">The De Ritis (aspartate transaminase/alanine transaminase) ratio as a predictor of oncological outcomes in patients after surgery for upper urinary tract urothelial carcinoma.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Cho YH, Hwang JE, Chung HS, Kim MS, Hwang EC, Jung SI, Kang TW, Kwon DD, Choi SH, Kim HT, Kim TH, Kwon TG, Noh JH, Kim MK, Kim CS, Kang SG, Kang SH, Cheon J, Lee CH, Ku JY, Ha HK, Tae BS, Jeong CW, Ku JH, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Urol Nephrol. 2017 Aug;49(8):1383-1390. doi: 10.1007/s11255-017-1613-z. Epub 2017 May 8.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28484945</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28469275/">Prognostic value of impaired estimated glomerular filtration rate in intravesical BCG-treated non-muscle-invasive bladder cancer patients.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Tae BS, Kim JK, Kang M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Sci Rep. 2017 May 3;7(1):1380. doi: 10.1038/s41598-017-01532-7.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28469275 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28549862/">Clinicopathologic Characteristics and Prognosis of Xp11.2 Translocation Renal Cell Carcinoma: Multicenter, Propensity Score Matching Analysis.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Jeong CW, Song C, Jeon HG, Seo SI, Hong SK, Byun SS, Chung JS, Hong SH, Hwang EC, Kim HH, Kwak C; Korean Renal Cancer Study Group.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2017 Oct;15(5):e819-e825. doi: 10.1016/j.clgc.2017.04.015. Epub 2017 Apr 26.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28549862</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28446011/">Development of Decision Support Formulas for the Prediction of Bladder Outlet Obstruction and Prostatic Surgery in Patients With Lower Urinary Tract Symptom/Benign Prostatic Hyperplasia: Part II, External Validation and Usability Testing of a Smartphone App.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Jeong SJ, Cho SY, Yoo C, Jeong CW, Ku JH, Oh SJ.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Neurourol J. 2017 Apr;21(Suppl 1):S66-75. doi: 10.5213/inj.1734854.427. Epub 2017 Apr 21.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28446011 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28446010/">Development of Decision Support Formulas for the Prediction of Bladder Outlet Obstruction and Prostatic Surgery in Patients With Lower Urinary Tract Symptom/Benign Prostatic Hyperplasia: Part I, Development of the Formula and its Internal Validation.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Yoo C, Cho SY, Jeong SJ, Jeong CW, Ku JH, Oh SJ.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Neurourol J. 2017 Apr;21(Suppl 1):S55-65. doi: 10.5213/inj.1734852.426. Epub 2017 Apr 21.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28446010 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28347659/">Variant histology as a significant predictor of survival after radical nephroureterectomy in patients with upper urinary tract urothelial carcinoma.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Moon KC, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urol Oncol. 2017 Jul;35(7):458.e9-458.e15. doi: 10.1016/j.urolonc.2017.02.010. Epub 2017 Mar 24.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28347659</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28320523/">Roles of fluid shear stress and retinoic acid in the differentiation of primary cultured human podocytes.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yang SH, Choi JW, Huh D, Jo HA, Kim S, Lim CS, Lee JC, Kim HC, Kwon HM, Jeong CW, Kwak C, Joo KW, Kim YS, Kim DK.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Exp Cell Res. 2017 May 1;354(1):48-56. doi: 10.1016/j.yexcr.2017.03.026. Epub 2017 Mar 16.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28320523</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28284894/">Can partial nephrectomy provide equal oncological efficiency and safety compared with radical nephrectomy in patients with renal cell carcinoma (≥4cm)? A propensity score-matched study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee H, Oh JJ, Byun SS, Jeong CW, Kwak C, Jeong BC, Jeon SS, Lee HM, Choi HY, Seo SI.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urol Oncol. 2017 Jun;35(6):379-385. doi: 10.1016/j.urolonc.2017.02.002. Epub 2017 Mar 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28284894</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28039452/">Preoperative neutrophil-lymphocyte ratio can significantly predict mortality outcomes in patients with non-muscle invasive bladder cancer undergoing transurethral resection of bladder tumor.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Oncotarget. 2017 Feb 21;8(8):12891-12901. doi: 10.18632/oncotarget.14179.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28039452 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28111837/">Surgical treatment of renal cell carcinoma: Can morphological features of inferior vena cava tumor thrombus on computed tomography or magnetic resonance imaging be a prognostic factor?
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choi DK, Jeon HG, Jeong CW, Kwak C, Song C, Chung J, Hong SK, Hong SH, Seo SI; Korean Renal Cancer Study Group.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2017 Feb;24(2):102-109. doi: 10.1111/iju.13272. Epub 2017 Jan 22.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28111837</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28174011/">Prognostic Role of Neutrophil-to-lymphocyte Ratio-based Markers During Pre- and Postadjuvant Chemotherapy in Patients With Advanced Urothelial Carcinoma of Upper Urinary Tract.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2017 Aug;15(4):e633-e643. doi: 10.1016/j.clgc.2017.01.003. Epub 2017 Jan 12.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28174011</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28162942/">Can the Preoperative Neutrophil-to-Lymphocyte Ratio Significantly Predict the Conditional Survival Probability in Muscle-invasive Bladder Cancer Patients Undergoing Radical Cystectomy?
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Balpukov UJ, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2017 Jun;15(3):e411-e420. doi: 10.1016/j.clgc.2016.10.015. Epub 2017 Jan 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28162942</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/28097263/">Predicting biochemical recurrence in patients with high-risk prostate cancer using the apparent diffusion coefficient of magnetic resonance imaging.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yoon MY, Park J, Cho JY, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Investig Clin Urol. 2017 Jan;58(1):12-19. doi: 10.4111/icu.2017.58.1.12. Epub 2017 Jan 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>28097263 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<Title_span >2016</Title_span>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/27861519/">Pathological T3a Upstaging of Clinical T1 Renal Cell Carcinoma: Outcomes According to Surgical Technique and Predictors of Upstaging.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong SH, Kim JK, Park J, Jeon HJ, Yoon MY, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2016 Nov 18;11(11):e0166183. doi: 10.1371/journal.pone.0166183. eCollection 2016.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>27861519 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/27159369/">Perioperative Blood Transfusion as a Significant Predictor of Biochemical Recurrence and Survival after Radical Prostatectomy in Patients with Prostate Cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Kim HS, Park J, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2016 May 9;11(5):e0154918. doi: 10.1371/journal.pone.0154918. eCollection 2016.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>27159369 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/27021929/">Renal cell carcinoma in end-stage renal disease: Multi-institutional comparative analysis of survival.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Song C, Hong SH, Chung JS, Byun SS, Kwak C, Jeong CW, Seo SI, Jeon HG, Seo IY.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2016 Jun;23(6):465-71. doi: 10.1111/iju.13084. Epub 2016 Mar 28.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>27021929</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26890006/">Clinical Nomograms to Predict Stone-Free Rates after Shock-Wave Lithotripsy: Development and Internal-Validation.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Ha SB, Jeon CH, Oh JJ, Cho SY, Oh SJ, Kim HH, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2016 Feb 18;11(2):e0149333. doi: 10.1371/journal.pone.0149333. eCollection 2016.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26890006 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26966726/">The establishment of KORCC (KOrean Renal Cell Carcinoma) database.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Byun SS, Hong SK, Lee S, Kook HR, Lee E, Kim HH, Kwak C, Ku JH, Jeong CW, Lee JY, Hong SH, Kim YJ, Hwang EC, Kwon TG, Kim TH, Kang SH, Kim SH, Chung J.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Investig Clin Urol. 2016 Jan;57(1):50-7. doi: 10.4111/icu.2016.57.1.50. Epub 2016 Jan 11.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26966726 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26497823/">Laparoscopic radical nephroureterectomy is associated with worse survival outcomes than open radical nephroureterectomy in patients with locally advanced upper tract urothelial carcinoma.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Ku JH, Jeong CW, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2016 Jun;34(6):859-69. doi: 10.1007/s00345-015-1712-3. Epub 2015 Oct 23.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26497823</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26511817/">Conditional Survival and Associated Prognostic Factors in Patients with Upper Tract Urothelial Carcinoma after Radical Nephroureterectomy: A Retrospective Study at a Single Institution.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Kim HS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Cancer Res Treat. 2016 Apr;48(2):621-31. doi: 10.4143/crt.2015.220. Epub 2015 Sep 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26511817 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26459040/">Correlation Between the Timing of Diagnostic Ureteroscopy and Intravesical Recurrence in Upper Tract Urothelial Cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee JK, Kim KB, Park YH, Oh JJ, Lee S, Jeong CW, Jeong SJ, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2016 Feb;14(1):e37-41. doi: 10.1016/j.clgc.2015.07.008. Epub 2015 Aug 6.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26459040</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26152275/">The Prognostic Significance of the Early Postoperative Neutrophil-to-Lymphocyte Ratio in Patients with Urothelial Carcinoma of the Bladder Undergoing Radical Cystectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Ann Surg Oncol. 2016 Jan;23(1):335-42. doi: 10.1245/s10434-015-4708-8. Epub 2015 Jul 8.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26152275</TD>

        </TR>
    </Table>
</div>
<Title_span >2015</Title_span>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26742963/">Adjuvant chemotherapy for locally advanced upper tract urothelial carcinoma: updated results of the Seoul National University Hospital experience.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Lee JS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>
        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Braz J Urol. 2015 Nov-Dec;41(6):1067-79. doi: 10.1590/S1677-5538.IBJU.2015.0009.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26742963 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26579498/">Disease-Free Survival at 2 and 3 Years is a Significant Early Surrogate Marker Predicting the 5-Year Overall Survival in Patients Treated with Radical Cystectomy for Urothelial Carcinoma of the Bladder: External Evaluation and Validation in a Cohort of Korean Patients.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Front Oncol. 2015 Oct 29;5:246. doi: 10.3389/fonc.2015.00246. eCollection 2015.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26579498 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26617856/">Differences in peritumoral pseudocapsule characteristics according to clinicopathological factors in clinical T1a renal tumors.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim M, Choi WS, Jeong CW, Ku JH, Kim HH, Moon KC, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Clin Exp Pathol. 2015 Sep 1;8(9):11323-31. eCollection 2015.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26617856 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26212449/">Prognostic factors for conditional survival in patients with muscle-invasive urothelial carcinoma of the bladder treated with radical cystectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Kim HS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Sci Rep. 2015 Jul 27;5:12171. doi: 10.1038/srep12171.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26212449 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26240493/">Survival Outcomes and Predictive Factors for Female Urethral Cancer: Long-term Experience with Korean Patients.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Korean Med Sci. 2015 Aug;30(8):1143-9. doi: 10.3346/jkms.2015.30.8.1143. Epub 2015 Jul 15.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26240493 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26139078/">Can body mass index predict survival outcomes in patients treated with radical nephroureterectomy for upper-tract urothelial carcinoma?
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Urol Nephrol. 2015 Aug;47(8):1311-20. doi: 10.1007/s11255-015-1039-4. Epub 2015 Jul 3.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26139078</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26185537/">Adjuvant Chemotherapy Correlates with Improved Survival after Radical Cystectomy in Patients with pT3b (Macroscopic Perivesical Tissue Invasion) Bladder Cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Piao S, Moon KC, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Cancer. 2015 Jun 29;6(8):750-8. doi: 10.7150/jca.12259. eCollection 2015.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26185537 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25843594/">External Validation and Evaluation of Reliability and Validity of the Modified Seoul National University Renal Stone Complexity Scoring System to Predict Stone-Free Status After Retrograde Intrarenal Surgery.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Park J, Kang M, Jeong CW, Oh S, Lee JW, Lee SB, Son H, Jeong H, Cho SY.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Endourol. 2015 Aug;29(8):888-93. doi: 10.1089/end.2014.0901. Epub 2015 May 19.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25843594</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25959144/">Histological variant as the significant predictor of survival in patients with lymph node positive urothelial carcinoma of the bladder.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Moon KC, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Sci Rep. 2015 May 11;5:9626. doi: 10.1038/srep09626.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25959144 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25990340/">Prognostic Value of Body Mass Index According to Histologic Subtype in Nonmetastatic Renal Cell Carcinoma: A Large Cohort Analysis.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee WK, Hong SK, Lee S, Kwak C, Oh JJ, Jeong CW, Kim YJ, Kang SH, Hong SH, Byun SS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2015 Oct;13(5):461-8. doi: 10.1016/j.clgc.2015.04.012. Epub 2015 May 4.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25990340</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25874043/">The prognostic impact of perioperative blood transfusion on survival in patients with bladder urothelial carcinoma treated with radical cystectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee JS, Kim HS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Korean J Urol. 2015 Apr;56(4):295-304. doi: 10.4111/kju.2015.56.4.295. Epub 2015 Mar 26.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25874043 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25803284/">Hypertriglyceridemia is a potential preoperative predictor for biochemical recurrence after radical prostatectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Ku JH, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2015 Mar 24;10(3):e0122438. doi: 10.1371/journal.pone.0122438. eCollection 2015.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25803284 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25886012/">Are urothelial carcinomas of the upper urinary tract a distinct entity from urothelial carcinomas of the urinary bladder? Behavior of urothelial carcinoma after radical surgery with respect to anatomical location: a case control study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BMC Cancer. 2015 Mar 18;15:149. doi: 10.1186/s12885-015-1161-9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25886012 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/26005967/">Preoperative erectile function and the pathologic features of prostate cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Lee S, Jeong SJ, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Braz J Urol. 2015 Mar-Apr;41(2):265-73. doi: 10.1590/S1677-5538.IBJU.2015.02.12.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>26005967 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25683984/">The characteristics of recurrent upper tract urothelial carcinoma after radical nephroureterectomy without bladder cuff excision.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Yonsei Med J. 2015 Mar;56(2):375-81. doi: 10.3349/ymj.2015.56.2.375.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25683984 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25726498/">Prostate-specific antigen kinetic profiles during androgen deprivation therapy as prognostic factors in castration-resistant prostate cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim M, Lee J, Jeong CW, Ku JH, Kim HH, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urol Oncol. 2015 May;33(5):203.e1-9. doi: 10.1016/j.urolonc.2015.01.017. Epub 2015 Feb 26.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25726498</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25600022/">Prognostic value of systemic inflammatory responses in patients with upper urinary tract urothelial carcinoma.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim M, Moon KC, Choi WS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2015 Oct;33(10):1439-57. doi: 10.1007/s00345-015-1484-9. Epub 2015 Jan 20.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25600022</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25584490/">The prognostic value of pretreatment of systemic inflammatory responses in patients with urothelial carcinoma undergoing radical cystectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ku JH, Kang M, Kim HS, Jeong CW, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Br J Cancer. 2015 Feb 3;112(3):461-7. doi: 10.1038/bjc.2014.631. Epub 2015 Jan 13.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25584490 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25581719/">Characteristics and significant predictors of detecting underlying diseases in adults with asymptomatic microscopic hematuria: a large case series of a Korean population.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Lee S, Jeong SJ, Hong SK, Byun SS, Lee SE, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2015 Apr;22(4):389-93. doi: 10.1111/iju.12697. Epub 2015 Jan 12.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25581719</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25458737/">A propensity-matched comparison of perioperative complications and of chronic kidney disease between robot-assisted laparoscopic partial nephrectomy and radiofrequency ablative therapy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim SH, Lee ES, Kim HH, Kwak C, Ku JH, Lee SE, Hong SK, Jeong CW, Kim SH, Cho JY, Hwang SI, Lee HJ, Byun SS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Asian J Surg. 2015 Jul;38(3):126-33. doi: 10.1016/j.asjsur.2014.09.005. Epub 2014 Nov 4.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25458737</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25456840/">Effect of sex on prognosis of urothelial carcinoma: propensity score matching analysis.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Clin Genitourin Cancer. 2015 Apr;13(2):e113-21. doi: 10.1016/j.clgc.2014.09.006. Epub 2014 Nov 4.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25456840</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25315960/">Effects of new 1-step posterior reconstruction method on recovery of continence after robot-assisted laparoscopic prostatectomy: results of a prospective, single-blind, parallel group, randomized, controlled trial.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Lee JK, Oh JJ, Lee S, Jeong SJ, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>J Urol. 2015 Mar;193(3):935-42. doi: 10.1016/j.juro.2014.10.023. Epub 2014 Oct 12.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25315960 Clinical Trial.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24825471/">The clinical significance of intra-operative ureteral frozen section analysis at radical cystectomy for urothelial carcinoma of the bladder.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Moon KC, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2015 Mar;33(3):359-65. doi: 10.1007/s00345-014-1306-5. Epub 2014 May 14.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24825471</TD>

        </TR>
    </Table>
</div>
<Title_span >2014</Title_span>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25599072/">The role of 3-tesla diffusion-weighted magnetic resonance imaging in selecting prostate cancer patients for active surveillance.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Park YH, Hwang SI, Lee S, Jeong SJ, Hong SK, Byun SS, Lee HJ, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Prostate Int. 2014 Dec;2(4):169-75. doi: 10.12954/PI.14057. Epub 2014 Dec 30.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25599072 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25361709/">Characteristics and prognostic value of papillary histologic subtype in nonmetastatic renal cell carcinoma in Korea: a multicenter study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee WK, Lee SE, Hong SK, Jeong CW, Park YH, Kang SH, Kim YJ, Hong SH, Choi WS, Byun SS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urol J. 2014 Nov 1;11(5):1884-90.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25361709</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25191845/">Impact of squamous and glandular differentiation on oncologic outcomes in upper and lower tract urothelial carcinoma.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee YJ, Moon KC, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2014 Sep 5;9(9):e107027. doi: 10.1371/journal.pone.0107027. eCollection 2014.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25191845 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25035206/">Risk prediction models of locoregional failure after radical cystectomy for urothelial carcinoma: external validation in a cohort of korean patients.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ku JH, Kim M, Jeong CW, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Radiat Oncol Biol Phys. 2014 Aug 1;89(5):1032-1037. doi: 10.1016/j.ijrobp.2014.04.049. Epub 2014 Jul 8.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25035206</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25296594/">Salvage treatment with low-dose weekly paclitaxel in elderly or poor performance status patients with metastatic urothelial carcinoma.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Han JJ, Kim YJ, Kim JW, Chang H, Lee JO, Lee KW, Jeong CW, Kim JH, Hong SK, Bang SM, Byun SS, Lee SE, Lee JS.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Tumori. 2014 Jul-Aug;100(4):439-45. doi: 10.1700/1636.17906.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25296594</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/25132891/">Comparison of robotic and open partial nephrectomy: Single-surgeon matched cohort study.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Byun S, Hong SK, Jeong CW, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Can Urol Assoc J. 2014 Jul;8(7-8):E471-5. doi: 10.5489/cuaj.1679.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>25132891 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24937260/">Multifactorial, site-specific recurrence models after radical cystectomy for urothelial carcinoma: external validation in a cohort of Korean patients.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim HS, Kim M, Jeong CW, Kwak C, Kim HH, Ku JH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2014 Jun 17;9(6):e100491. doi: 10.1371/journal.pone.0100491. eCollection 2014.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24937260 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24936784/">Pre- and post-operative nomograms to predict recurrence-free probability in korean men with clinically localized prostate cancer.</Table_title>


<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Choi WS, Park YH, Cho SY, Lee S, Lee SB, Ku JH, Hong SK, Byun SS, Jeong H, Kwak C, Kim HH, Lee E, Lee SE; Seoul National University-Uro-Oncology Group.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2014 Jun 17;9(6):e100053. doi: 10.1371/journal.pone.0100053. eCollection 2014.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24936784 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24815071/">Inhibition of autophagy potentiates atorvastatin-induced apoptotic cell death in human bladder cancer cells in vitro.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kang M, Jeong CW, Ku JH, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Mol Sci. 2014 May 8;15(5):8106-21. doi: 10.3390/ijms15058106.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24815071 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24807736/">Predictors of positive surgical margins and their location in Korean men undergoing radical prostatectomy.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Cho SY, Jeong CW, Lee SB, Ku JH, Hong SK, Byun SS, Kwak C, Kim HH, Lee SE, Jeong H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2014 Sep;21(9):894-8. doi: 10.1111/iju.12465. Epub 2014 May 8.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24807736</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24867195/">Electronically implemented clinical indicators based on a data warehouse in a tertiary hospital: its clinical benefit and effectiveness.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Yoo S, Kim S, Lee KH, Jeong CW, Youn SW, Park KU, Moon SY, Hwang H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Med Inform. 2014 Jul;83(7):507-16. doi: 10.1016/j.ijmedinf.2014.04.001. Epub 2014 Apr 29.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24867195</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24710020/">Mobile application-based Seoul National University Prostate Cancer Risk Calculator: development, validation, and comparative analysis with two Western risk calculators in Korean men.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Lee S, Jung JW, Lee BK, Jeong SJ, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2014 Apr 7;9(4):e94441. doi: 10.1371/journal.pone.0094441. eCollection 2014.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24710020 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24741414/">The nephrometry score: is it effective for predicting perioperative outcome during robot-assisted partial nephrectomy?
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Yeon JS, Son SJ, Lee YJ, Cha WH, Choi WS, Chung JW, Lee BK, Lee S, Jeong CW, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Korean J Urol. 2014 Apr;55(4):254-9. doi: 10.4111/kju.2014.55.4.254. Epub 2014 Apr 10.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24741414 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24623504/">Modified Seoul National University Renal Stone Complexity score for retrograde intrarenal surgery.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jung JW, Lee BK, Park YH, Lee S, Jeong SJ, Lee SE, Jeong CW.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urolithiasis. 2014 Aug;42(4):335-40. doi: 10.1007/s00240-014-0650-7. Epub 2014 Mar 13.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24623504</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24492489/">Genetic variants in the CYP24A1 gene are associated with prostate cancer risk and aggressiveness in a Korean study population.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Byun SS, Lee SE, Hong SK, Jeong CW, Choi WS, Kim D, Kim HJ, Myung SC.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Prostate Cancer Prostatic Dis. 2014 Jun;17(2):149-56. doi: 10.1038/pcan.2014.1. Epub 2014 Feb 4.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24492489</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24421896/">External validation and evaluation of reliability and validity of the S-ReSC scoring system to predict stone-free status after percutaneous nephrolithotomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Jeong CW, Jung JH, Lee SB, Jeong H, Son H, Kim HH, Oh SJ, Cho SY.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2014 Jan 8;9(1):e83628. doi: 10.1371/journal.pone.0083628. eCollection 2014.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24421896 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24362883/">Impact of positive surgical margins and their locations after radical prostatectomy: comparison of biochemical recurrence according to risk stratification and surgical modality.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Choo MS, Cho SY, Ko K, Jeong CW, Lee SB, Ku JH, Hong SK, Byun SS, Kwak C, Kim HH, Lee SE, Jeong H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2014 Dec;32(6):1401-9. doi: 10.1007/s00345-013-1230-0. Epub 2013 Dec 21.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24362883</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24120391/">Incidence and risk factors of chronic kidney disease in korean patients with t1a renal cell carcinoma before and after radical or partial nephrectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Byun SS, Lee SE, Hong SK, Jeong CW, Kim D, Kim HJ, Myung SC.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Gene. 2014 Jan 1;533(1):86-93. doi: 10.1016/j.gene.2013.09.119. Epub 2013 Oct 9.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24120391</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24118633/">Partial nephrectomy versus radical nephrectomy for non-metastatic pathological T3a renal cell carcinoma: a multi-institutional comparative analysis.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Byun SS, Lee SE, Hong SK, Lee ES, Kim HH, Kwak C, Ku JH, Jeong CW, Kim YJ, Kang SH, Hong SH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2014 Apr;21(4):352-7. doi: 10.1111/iju.12283. Epub 2013 Sep 30.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24118633</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23937424/">Trends in renal function after radical nephrectomy: a multicentre analysis.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Chung JS, Son NH, Byun SS, Lee SE, Hong SK, Jeong CW, Lee SC, Chae DW, Choi WS, Park YH, Hong SH, Kim YJ, Kang SH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BJU Int. 2014 Mar;113(3):408-15. doi: 10.1111/bju.12277. Epub 2013 Aug 13.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23937424</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23832420/">Development and validation of nomograms to predict the recovery of urinary continence after radical prostatectomy: comparisons between immediate, early, and late continence.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong SJ, Yeon JS, Lee JK, Cha WH, Jeong JW, Lee BK, Lee SC, Jeong CW, Kim JH, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2014 Apr;32(2):437-44. doi: 10.1007/s00345-013-1127-y. Epub 2013 Jul 6.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23832420</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23817888/">Quantification of median lobe protrusion and its impact on the base surgical margin status during robot-assisted laparoscopic prostatectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Lee S, Oh JJ, Lee BK, Lee JK, Jeong SJ, Hong SK, Byun SS, Choe G, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2014 Apr;32(2):419-23. doi: 10.1007/s00345-013-1118-z. Epub 2013 Jul 2.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23817888</TD>

        </TR>
    </Table>
</div>
<Title_span>2013</Title_span>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/24044093/">Comparison of continence recovery between robot-assisted laparoscopic prostatectomy and open radical retropubic prostatectomy: a single surgeon experience.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Son SJ, Lee SC, Jeong CW, Jeong SJ, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Korean J Urol. 2013 Sep;54(9):598-602. doi: 10.4111/kju.2013.54.9.598. Epub 2013 Sep 10.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>24044093 Free PMC article.</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23830078/">The prognostic value of pathologic prostate-specific antigen mass ratio in patients with localized prostate cancer with negative surgical resection margins.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Lee S, Jeong CW, Jeong SJ, Hong SK, Choi W, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urology. 2013 Oct;82(4):865-9. doi: 10.1016/j.urology.2013.04.040. Epub 2013 Jul 3.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23830078</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23609065/">No increase in risk of microscopic hematuria with aspirin use by asymptomatic healthy people.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Lee S, Byun SS, Lee DH, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>JAMA Intern Med. 2013 Jun 24;173(12):1145-6. doi: 10.1001/jamainternmed.2013.567.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23609065 No abstract available.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23432960/">Does obesity affect the accuracy of prostate-specific antigen (PSA) for predicting prostate cancer among men undergoing prostate biopsy.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Jeong SJ, Lee BK, Jeong CW, Byun SS, Hong SK, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BJU Int. 2013 Aug;112(4):E265-71. doi: 10.1111/j.1464-410X.2012.11766.x. Epub 2013 Feb 21.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23432960</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23824752/">Seoul National University Renal Stone Complexity Score for Predicting Stone-Free Rate after Percutaneous Nephrolithotomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Jung JW, Cha WH, Lee BK, Lee S, Jeong SJ, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>PLoS One. 2013 Jun 18;8(6):e65888. doi: 10.1371/journal.pone.0065888. Print 2013.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23824752 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22585359/">Is there any association between the severity of lower urinary tract symptoms and the risk of biopsy-detectable prostate cancer in patients with PSA level below 20 ng/ml in multi-core prostate biopsy?
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Jeong SJ, Jeong CW, Byun SS, Hong SK, Choe G, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Prostate. 2013 Jan;73(1):42-7. doi: 10.1002/pros.22537. Epub 2012 May 14.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22585359</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22441311/">Effect of dorsal vascular complex size on the recovery of continence after radical prostatectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Oh JJ, Jeong SJ, Hong SK, Byun SS, Hwang SI, Lee HJ, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2013 Apr;31(2):383-8. doi: 10.1007/s00345-012-0857-6. Epub 2012 Mar 24.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22441311</TD>

        </TR>
    </Table>
</div>
<Title_span>2012</Title_span>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/23301125/">Biochemical recurrence in Gleason score 7 prostate cancer in korean men: significance of the primary Gleason grade.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ro YK, Lee S, Jeong CW, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Korean J Urol. 2012 Dec;53(12):826-9. doi: 10.4111/kju.2012.53.12.826. Epub 2012 Dec 20.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>23301125 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22846142/">Urinary continence after radical prostatectomy: predictive factors of recovery after 1 year of surgery.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong SJ, Kim HJ, Kim JH, Oh JJ, Lee SC, Jeong CW, Yoon CY, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2012 Dec;19(12):1091-8. doi: 10.1111/j.1442-2042.2012.03106.x. Epub 2012 Jul 29.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22846142</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22656409/">Can conventional magnetic resonance imaging, prostate needle biopsy, or their combination predict the laterality of clinically localized prostate cancer?
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Ku JH, Moon KC, Hong SK, Byun SS, Cho JY, Kim HH, Kim SH, Lee SE, Kwak C.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Urology. 2012 Jun;79(6):1322-7. doi: 10.1016/j.urology.2012.01.080.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22656409</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22587373/">Nomograms to predict the pathological stage of clinically localized prostate cancer in Korean men: comparison with western predictive tools using decision curve analysis.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Jeong SJ, Hong SK, Lee SB, Ku JH, Byun SS, Jeong H, Kwak C, Kim HH, Lee E, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2012 Sep;19(9):846-52. doi: 10.1111/j.1442-2042.2012.03040.x. Epub 2012 May 15.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22587373</TD>

        </TR>
    </Table>
</div>

<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22404556/">Novel posterior reconstruction technique during robot-assisted laparoscopic prostatectomy: description and comparative outcomes.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Oh JJ, Jeong SJ, Hong SK, Byun SS, Choe G, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int J Urol. 2012 Jul;19(7):683-7. doi: 10.1111/j.1442-2042.2012.02988.x. Epub 2012 Mar 8.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22404556</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22314007/">Patients aged more than 70 had higher risk of locally advanced prostate cancers and biochemical recurrence in Korea.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim JK, Cho SY, Jeong CW, Lee SB, Ku JH, Hong SK, Byun SS, Kwak C, Him HH, Lee SE, Jeong H.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BJU Int. 2012 Aug;110(4):505-9. doi: 10.1111/j.1464-410X.2011.10927.x. Epub 2012 Feb 7.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22314007</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21516470/">Significance of smoking status regarding outcomes after radical prostatectomy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Hong SK, Jeong CW, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Int Urol Nephrol. 2012 Feb;44(1):119-24. doi: 10.1007/s11255-011-9964-3. Epub 2011 Apr 24.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21516470</TD>

        </TR>
    </Table>
</div>

<Title_span>2011</Title_span>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/22087359/">Interval from Prostate Biopsy to Robot-Assisted Laparoscopic Radical Prostatectomy (RALP): Effects on Surgical Difficulties.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Kim IS, Na W, Nam JS, Oh JJ, Jeong CW, Hong SK, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Korean J Urol. 2011 Oct;52(10):664-8. doi: 10.4111/kju.2011.52.10.664. Epub 2011 Oct 19.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>22087359 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21946230/">The prognostic significance of percentage of tumour involvement according to disease risk group in men treated with radical prostatectomy.
</Table_title>
<Table>
        <TR>
            <TD>Authors</TD><TD>Oh JJ, Lee SC, Jeong CW, Yoon CY, Jeong SJ, Hong SK, Byun SS, Rho YK, Choe G, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Asian J Androl. 2011 Nov;13(6):828-32. doi: 10.1038/aja.2011.111. Epub 2011 Sep 26.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21946230 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21706038/">Younger patients have poorer biochemical outcome after radical prostatectomy in high-risk prostate cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Hong SK, Nam JS, Na W, Oh JJ, Yoon CY, Jeong CW, Kim HJ, Byun SS, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Asian J Androl. 2011 Sep;13(5):719-23. doi: 10.1038/aja.2011.39. Epub 2011 Jun 27.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21706038 Free PMC article.</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21430020/">Biochemical recurrence after radical prostatectomy with or without pelvic lymphadenectomy in Korean men with high-risk prostate cancer.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ku JH, Jeong CW, Park YH, Cho MC, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Jpn J Clin Oncol. 2011 May;41(5):656-62. doi: 10.1093/jjco/hyr030. Epub 2011 Mar 23.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21430020</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21299453/">Nerve-sparing procedure in radical prostatectomy: a risk factor for hernia repair following open retropubic, pure laparoscopic and robot-assisted laparoscopic procedures.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ku JH, Jeong CW, Park YH, Cho MC, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Scand J Urol Nephrol. 2011 Apr;45(3):164-70. doi: 10.3109/00365599.2010.544674. Epub 2011 Feb 8.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21299453</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21083642/">Prediction of outcomes after radical prostatectomy in patients diagnosed with prostate cancer of biopsy Gleason score ≥ 8 via contemporary multi (≥ 12)-core prostate biopsy.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Hong SK, Oh JJ, Jeong SJ, Jeong CW, Kim IS, Park JM, Byun SS, Choe G, Lee HJ, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BJU Int. 2011 Jul;108(2):217-22. doi: 10.1111/j.1464-410X.2010.09814.x. Epub 2010 Nov 17.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21083642</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/21199287/">Prediction of pathological outcomes for a single microfocal (≤3 mm) Gleason 6 prostate cancer detected via contemporary multicore (≥12) biopsy in men with prostate-specific antigen ≤10 ng/mL.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Hong SK, Na W, Park JM, Byun SS, Oh JJ, Nam JS, Jeong CW, Choe G, Lee HJ, Hwang SI, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BJU Int. 2011 Oct;108(7):1101-5. doi: 10.1111/j.1464-410X.2010.09996.x. Epub 2010 Dec 24.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>21199287</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/20938462/">Relationship of statins to clinical presentation and biochemical outcomes after radical prostatectomy in Korean patients.
</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Ku JH, Jeong CW, Park YH, Cho MC, Kwak C, Kim HH.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>Prostate Cancer Prostatic Dis. 2011 Mar;14(1):63-8. doi: 10.1038/pcan.2010.39. Epub 2010 Oct 12.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>20938462</TD>

        </TR>
    </Table>
</div>
<div>
<Table_title target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/20804473/">Application of simplified Fuhrman grading system in clear-cell renal cell carcinoma.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Hong SK, Jeong CW, Park JH, Kim HS, Kwak C, Choe G, Kim HH, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>BJU Int. 2011 Feb;107(3):409-15. doi: 10.1111/j.1464-410X.2010.09561.x. Epub 2010 Aug 26.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>20804473</TD>

        </TR>
    </Table>
</div>
<Title_span>2009</Title_span>
<div>
<Table_title href="https://pubmed.ncbi.nlm.nih.gov/19214529/">Chronic pulmonary disease negatively influences the prognosis of patients with advanced prostate cancer.</Table_title>

<Table>
        <TR>
            <TD>Authors</TD><TD>Jeong CW, Ku JH, Kwak C, Kim HH, Lee SE.</TD>

        </TR>
        <TR>
            <TD>Journal Information</TD><TD>World J Urol. 2009 Oct;27(5):643-52. doi: 10.1007/s00345-009-0375-3. Epub 2009 Feb 13.</TD>

        </TR>
        <TR>
            <TD>PMID</TD><TD>19214529</TD>

        </TR>
    </Table>
</div>
    </Wrapper_div>
    )
}
function Super_GUC(){
    return (
        <Wrapper>
            <Slide imgURL={Publications} inputText="Publications"/>
            <Publication/>
        </Wrapper>
    )
}  

const Wrapper = styled.div`
font-family: "En";        
position : relative; 
top : 90px;
width : 1200px; 
margin : 0 auto; 
`
const Title_span_ = styled.span`
font-family: "Title";        
    display : inline-block;
    font-size : 35px; 
    font-weight : bold;
`
export default Super_GUC;